export default {
  data() {
    return {
      sceneAudio: null,
      sceneAudioEndHandler: null,
    };
  },
  beforeDestroy() {
    this.clearSceneAudio();
  },
  methods: {
    playSceneAudio(folder, fileName, onEnded) {
      this.clearSceneAudio();
      if (!folder || !fileName) {
        if (typeof onEnded === "function") onEnded();
        return;
      }
      const normalizedFile = String(fileName);
      const handleOnce = (() => {
        let called = false;
        return () => {
          if (called) return;
          called = true;
          if (typeof onEnded === "function") {
            onEnded();
          }
        };
      })();
      try {
        const audioSrc = require(`@/assets/music/${folder}/${normalizedFile}.mp3`);
        const audio = new Audio(audioSrc);
        this.sceneAudioEndHandler = handleOnce;
        audio.addEventListener("ended", this.sceneAudioEndHandler);
        audio.addEventListener("error", this.sceneAudioEndHandler);
        audio
          .play()
          .then(() => {
            this.sceneAudio = audio;
          })
          .catch((err) => {
            console.log(
              `Scene audio play failed (${folder}/${normalizedFile}.mp3):`,
              err
            );
            handleOnce();
          });
        this.sceneAudio = audio;
      } catch (err) {
        console.log(
          `Scene audio not found (${folder}/${normalizedFile}.mp3):`,
          err
        );
        handleOnce();
      }
    },
    clearSceneAudio() {
      if (this.sceneAudio) {
        if (this.sceneAudioEndHandler) {
          this.sceneAudio.removeEventListener("ended", this.sceneAudioEndHandler);
          this.sceneAudio.removeEventListener("error", this.sceneAudioEndHandler);
        }
        try {
          this.sceneAudio.pause();
          this.sceneAudio.currentTime = 0;
        } catch (err) {
          console.log("Failed to reset scene audio:", err);
        }
        this.sceneAudio = null;
        this.sceneAudioEndHandler = null;
      }
    },
  },
};

